module.exports = __webpack_public_path__ + "img/loding.1b4d8aaa.gif";